import { RouteProps, Route, Switch } from "react-router-dom";
import React, { Component } from "react";
import appRoutes from './appRoutes';

interface AppRoutesProps {

}

const AppRoutes: React.FunctionComponent<AppRoutesProps> = (props) => {
    const routes: JSX.Element[] = [];

    appRoutes.map((value: RouteProps, index: number) => {
        const route: JSX.Element = (<Route {...value} key={index} />);
        routes.push(route);
    });

    return (
        <Switch>
            {routes}
        </Switch>
    )
}

export default AppRoutes;